const SystemUsersEnums = {
  keys: {},
  titles: {},
  profileKeys: {
    AUTH_USERS: 'auth_users'
  },
  routeKeys: {
    FIND: 'find',
    COUNT: 'count',
    AGGREGATE: 'aggregate',
    FIND_BY_ID: 'find_by_id'
  }
}

export default SystemUsersEnums
